<template>
  <div class="carousel-wrapper">
    <div class="carousel">
      <div class="bg-gray carousel-item-v2" 
      :class="{ center: index === 1 }"
      v-for="(image, index) in visibleImages" :key="index">
        <img v-if="image" 
        :key="currentIndex + '-' + index"
        :src="`/static/img/acCleaning/${image}`" 
        @mouseenter="stopAutoPlay"
        @mouseleave="AutoPlay"
        alt="carousel image" />
      </div>
    </div>
    <div v-if="images.length > 0" 
      class="controll-dot mt-5"
      >
      <span v-for="(dot,indexDot) in images.length" 
      :key="indexDot" 
      :class="{ 'active-dot': currentIndex === indexDot }"
      @click="currentIndex = indexDot"></span>
      <i @click="toggleAutoPlay" 
      :class="[autoPlayStatus ? 'fas fa-pause' : 'fas fa-play', {
        'active-player': autoPlayStatus
      }]" 
      class="player-control rounded-full p-2"></i>


    </div>
    <!-- true for show false for hidden -->
    <div v-if="false" class="d-flex flex-column gap-2 border-1" >
      display status working : for Dev
      <span>autoPlayStatus : {{ autoPlayStatus }}</span>
      <span class="material-icons">
        {{ autoPlayStatus ? 'pause' : 'play_arrow' }}
      </span>
      <span>currentIndex : {{ currentIndex }}</span>
      <span>images.length : {{ images.length }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: [Object, Array],
      default: () => []
    },
    customDuration: {
      type: Number,
      default: 3000
    }
  },
  data () {
    return {
      currentIndex: 0,
      autoPlayStatus: true,
      intervalId: null
    }
  },
  computed: {
    visibleImages () {
      const total = this.images.length
      if (total < 3) return this.images // กรณีรูปน้อยกว่า 3
      const start = this.currentIndex
      return [
        this.images[(start - 1 + total) % total],
        this.images[start],
        this.images[(start + 1) % total]
      ]
    }
  },
  created () {
    this.AutoPlay()
  },
  mounted () {
    this.startAutoPlay()
  },
  beforeDestroy () {
    this.stopAutoPlay()
  },
  methods: {
    AutoPlay () {
      this.autoPlayStatus = true
      this.startAutoPlay()
    },
    startAutoPlay () {
      if (this.intervalId !== null) return // Prevent multiple intervals
      this.intervalId = setInterval(() => {
        if (this.autoPlayStatus) {
          this.next()
        }
      }, this.customDuration)
    },
    stopAutoPlay () {
      if (this.intervalId !== null) {
        clearInterval(this.intervalId)
        this.intervalId = null
        this.autoPlayStatus = false
      }
    },
    toggleAutoPlay () {
      this.autoPlayStatus = !this.autoPlayStatus
      if (this.autoPlayStatus) {
        this.startAutoPlay()
      } else {
        this.stopAutoPlay()
      }
    },
    next () {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    prev () {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../static/sass/page/ac_cleaning.scss";


.carousel-wrapper {
  width: 100%;
  // max-width: 800px;
  margin: auto;
  text-align: center;
}
.carousel {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2%;
}
.carousel-item-v2 {
  flex: 0 0 30%;
  margin: 0 5px;
  transition: all 0.3s ease-in-out;
  border-radius: 10px;
}

.carousel-item-v2.center {
  // transform: scale(1.05);
  z-index: 2;
}
.carousel-item-v2 img {
  transition: all 0.3s ease-in-out;
  width: 360px;
  height: 360px;
  border-radius: 10px;
  // box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  &:hover {
    cursor: grab;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
  &:active {
    cursor: grabbing;
  }
}
.controll-dot {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: relative;
}
.controll-dot span {
  width: 14px;
  height: 14px;
  aspect-ratio: 1/1;
  background-color: #B2C2B9;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  transition: all 0.6s ease-in-out;

  &:hover {
    background-color: $light-blue;
  }

  &.active-dot {
    background-color: $secon-color;

    &:hover {
      background-color: $light-blue;
    }
  }

}


.player-control {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  background-color: #B2C2B9;
  color: #fff;
  transition: all 0.6s ease-in-out;

  &:hover {
    background-color: $light-blue;
  }

  &.active-player {
    background-color: $main-color;
    &:hover {
      background-color: $light-blue;
    }
  }

}


</style>



// WEBPACK FOOTER //
// src/components/materials/Carousel.vue